<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="options"
  [callbackFunction]="chartCallback"
></highcharts-chart>
<p *ngIf="!hasChartData" class="info-message">No data available</p>
